// extracted by mini-css-extract-plugin
export default {"Overlay":"TBdj5YMsn_feEvMvu2o5","Container":"vd3a73kwEth9RjMyg8am","Header":"W3XjWLr7rPyGWIuNLPYr","Close":"JfYKlwlO_S_9Ao9wGqeB","Content":"SbNiFJcePzKayB3v3jV3"};